import React, {FC, useCallback, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
// custom
import NavbarAdmin from '../../../../components/navbar/Navbar.admin';
import PaymentAdminForm, { PaymentFormData } from '../../../../components/forms/payments/Payment.admin.form';
import { IUserState } from '../../../../common/state/profile/user';
import { updatePaymentByIdAdmin } from '../../../../common/async/AsyncCalls';
import { IPayment, IPaymentState } from '../../../../common/state/payments/payment';
import SimpleSpinner from '../../../../components/loaders/spinners/SimpleSpinner';
// custom

const PaymentUpdateAdmin : FC = () => {
    const history = useHistory();    
    // states    
    const token: string = useSelector(({user} : {user: IUserState}) => user.token);
    const selectedPayment: IPayment | undefined = useSelector(({payment}: {payment: IPaymentState}) => payment.selected);
    
    // lifecycle
    const updatePaymentById = useCallback(async(formData: PaymentFormData)=>{
        if (!selectedPayment) return;
        try {
            await updatePaymentByIdAdmin(token, selectedPayment?.id, {
                amount: formData.amount,
                currency: formData.currency,                
                description: formData.description                
            });
            toast("Payment record updated successfully!");
            history.push({pathname: '/admin/payments'});
        } catch (err) {
            console.log('Error posting new payment recrod: ', (err as Error).message);
        }
    },[token]);

    return <React.Fragment>
        <NavbarAdmin/>
        <div
            className="w-screen p-4 lg:p-16 min-h-screen bg-gray-200 dark:bg-gray-800
                text-gray-700  dark:text-teal-400 flex flex-col justify-start items-start">
            <h2 className="text-gray-700 dark:text-teal-400 text-2xl mb-2">Update Payment Record</h2>
            <p className="text-gray-700 dark:text-gray-300 dartext-base mb-2">                
                Please note that the fields marked with * are required.                
            </p>
            <SimpleSpinner title='Loading details' loading={!selectedPayment}/>
            <PaymentAdminForm defaultFormData={{
                amount: selectedPayment?.amount?? 0,
                description: selectedPayment?.description?? '',
                currency: selectedPayment?.currency?? 'usd', 
            }}
            type = 'update' 
            onSubmit={updatePaymentById}/>
        </div>
    </React.Fragment>;
};

export default PaymentUpdateAdmin;